export default {
  name: 'team_members',

  translatedAttributes: [],

  toArray: item => ({
    id: item.id,
    first_name: item.first_name,
    last_name: item.last_name,
    email: item.email,
    password: item.password,
    password_confirmation: item.password_confirmation,
    mobile_code: item.mobile_code,
    mobile: item.mobile,
  }),

  fromArray: (data, initialItemData = {}) => ({
    ...initialItemData,
    id: data.id,
    first_name: data.first_name,
    last_name: data.last_name,
    name: data.fullName || (`${data.first_name} ${data.last_name}`),
    email: data.email,
    mobile_code: data.mobile_code,
    mobile: data.mobile,
    formatted_mobile: data.formatted_mobile,
    is_active: !!data.is_active,
    created_at: data.created_at,
  }),

  resolveValidationErrors: errors => ({
    id: errors.id,
    first_name: errors.first_name,
    last_name: errors.last_name,
    email: errors.email,
    password: errors.password,
    mobile: errors.mobile || errors.mobile_code,
  }),
}
